import { useLocation } from 'react-router-dom';

import { usePathSet } from '@/hooks/usePathSet';

export const useComplianceFrameworksBackPath = () => {
  const { state } = useLocation();
  const pathSet = usePathSet();

  if (state?.previousPath) {
    return state.previousPath;
  }

  return pathSet.projects;
};
